import React from 'react'
import { Typography } from "@material-ui/core";
import useStyles from "./styles";
import logo from "./logo.png";

export default function CzLogin() {

    var classes = useStyles();

  return (
    <div className={classes.logotypeContainer}>
    <div className={classes.logoParent}>
      <img src={logo} alt="logo" className={classes.logotypeImage} />
    </div>
    <Typography className={classes.logotypeText}>
      C-Zentrix Telephony Solution
    </Typography>
  </div>
  )
}
